module.exports = "/assets/326d0c193ee8bc988e14d4665e4adc50.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HY.png
// module id = 1456
// module chunks = 0